export default function AboutSection() {
  return (
    <section id="about" className="relative w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-50 mb-3">关于香蕉影视</h2>
          <p className="text-foreground-400 text-sm max-w-[600px] mx-auto">高清免费在线观看，重新定义你的追剧方式</p>
        </div>
        <div className="max-w-[900px] mx-auto">
          <div className="bg-background-200/70 rounded-xl border border-background-300/40 p-6 md:p-10">
            <div className="flex flex-col md:flex-row gap-8 items-start">
              <div className="flex-shrink-0 w-16 h-16 md:w-20 md:h-20 rounded-xl bg-primary-500/10 flex items-center justify-center border border-primary-500/20">
                <i className="ri-movie-2-line text-3xl md:text-4xl text-primary-400"></i>
              </div>
              <div className="flex-1">
                <h3 className="text-lg md:text-xl font-bold text-foreground-50 mb-4">打造极致观影新体验</h3>
                <p className="text-foreground-300 leading-relaxed text-sm md:text-base mb-4">
                  香蕉影视成立于2020年，是国内领先的高清在线视频平台之一。我们致力于为全球华语用户提供最优质的免费观影服务，
                  平台覆盖电影、电视剧、综艺、动漫、纪录片等全品类影视内容。依托先进的视频编码技术与全球CDN加速节点，
                  香蕉影视实现了真正的不缓冲秒开体验，无论何时何地，打开即可畅享高清流畅的观影之旅。
                </p>
                <p className="text-foreground-400 leading-relaxed text-sm">
                  平台始终坚持免费策略，让每一位用户都能无门槛地享受高品质视听娱乐。我们的内容团队每日精选热门佳作，
                  确保片库始终保持新鲜活力，成为你手机里不可或缺的追剧必备应用。
                </p>
                <div className="flex flex-wrap gap-3 mt-6">
                  <span className="px-3 py-1.5 rounded-full text-xs font-medium bg-background-300/60 text-foreground-300 border border-background-400/30 whitespace-nowrap">全品类覆盖</span>
                  <span className="px-3 py-1.5 rounded-full text-xs font-medium bg-background-300/60 text-foreground-300 border border-background-400/30 whitespace-nowrap">CDN 秒开技术</span>
                  <span className="px-3 py-1.5 rounded-full text-xs font-medium bg-background-300/60 text-foreground-300 border border-background-400/30 whitespace-nowrap">完全免费</span>
                  <span className="px-3 py-1.5 rounded-full text-xs font-medium bg-background-300/60 text-foreground-300 border border-background-400/30 whitespace-nowrap">多端同步</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}